import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React, {useEffect} from 'react';
import {useDebounce, useLocalStorage} from './_helpers';
import {InputAdornment, TextField} from '@mui/material';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';
import Icon from '@mui/material/Icon';
import {styled} from '@mui/material/styles';

/**
 * Brick that search in PR
 */
export default class SearchTextfieldWithIcon extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */
    static getReactComponent($) {
        return (props) => {
            const [textInput, setTextInput] = useLocalStorage('searchInput', useProperty($, 'Value') || '');
            const debounceSearch = useDebounce(textInput, 800);

            useEffect(() => {
                const sub = $.observe('Value').subscribe((v) => setTextInput(v));
                return () => sub.unsubscribe();
            }, []);

            useEffect(() => {
                if (debounceSearch) {
                    // Set the Value property before triggering the event
                    $.set('Value', textInput);
                    $.trigger('On Change');
                }
            }, [debounceSearch, textInput]);

            const handlerChange = (e) => {
                setTextInput(e.target.value);
            };

            const CustomWidthTooltip = styled(({className, textHTML, ...props}) => (
                <Tooltip {...props} title={
                    <div>
                        Search fields:
                        <li>Easy Request PR ID</li>
                        <li>SAP PR Number</li>
                        <li>Status</li>
                        <li>From</li>
                        <li>Spender</li>
                        <li>Requester</li>
                        <li>Title</li>
                        <li>Supplier</li>
                        <li>Category</li>
                        <li>Material</li>
                    </div>
                } classes={{popper: className}}/>
            ))({
                [`& .${tooltipClasses.tooltip}`]: {
                    maxWidth: 200,
                },
            });

            return (
                <TextField
                    value={textInput}
                    placeholder={useProperty($, 'Placeholder')}
                    size={'small'}
                    disabled={useProperty($, 'Disable') || false}
                    fullWidth
                    variant="outlined"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <Icon style={{display: !!useProperty($, 'Value') ? 'block' : 'none', cursor: 'pointer'}} onClick={() => {
                                    setTextInput('');
                                    $.set('Value', '');
                                    $.trigger('On Clear');
                                }}>close</Icon>
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position='end'>
                                <CustomWidthTooltip textHTML={useProperty($, 'Helper Text Icon') || ''}>
                                    <Icon
                                        style={{cursor: 'pointer'}}>{useProperty($, 'Input Adornment MUI Icon')}</Icon>
                                </CustomWidthTooltip>
                            </InputAdornment>
                        ),
                    }}
                    onChange={handlerChange}
                />
            );
        };
    };
};

registerBrick('0180231bef1348fa3041', SearchTextfieldWithIcon);
